import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=c31c2002&"
import script from "./qrcode.vue?vue&type=script&lang=ts&"
export * from "./qrcode.vue?vue&type=script&lang=ts&"
import style0 from "./qrcode.vue?vue&type=style&index=0&id=c31c2002&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports